// Shared human-label helper for task status enums, in the pattern of
// humanSuccessionStatus and humanOfficeStatus. Use this in any surface that
// shows task or assignment status to a member. Never render a raw enum value.

export const TASK_STATUS_LABEL: Record<string, string> = {
  not_started: "Not started",
  pending: "Waiting",
  accepted: "Accepted",
  in_progress: "In progress",
  completed: "Done",
  blocked: "Stuck",
  declined: "Declined",
};

export function humanTaskStatus(status: string | null | undefined): string {
  if (!status) return "Not started";
  return TASK_STATUS_LABEL[status] ?? "Not started";
}
